// extracted by mini-css-extract-plugin
export default {"card":"Card_card__oHhc5","content":"Card_content__KF0Wx","body":"Card_body__ULe4c"};